import { Service } from '../classes';
import { DataProvider } from './data-provider';

/**
 * @deprecated
 * implement AbstractDataProviderV2
 */
export class DataProviderFactory extends Service {
    private $http: angular.IHttpService;
    private cached: any;

    public static get $name(): string {
        return 'dataProviderFactory';
    }

    public static get $inject(): string[] {
        return ['$http'];
    }

    /**
     * @param $http
     */
    constructor($http: angular.IHttpService) {
        super();
        this.$http = $http;
        this.cached = {};
    }

    /**
     * @param {string} apiUrl
     * @return {DataProvider}
     */
    private build(apiUrl: string) {
        const provider = new DataProvider(this.$http);
        provider.setApiUrl(apiUrl);
        return provider;
    }

    /**
     * @param {string} apiUrl
     * @return {DataProvider}
     */
    public get(apiUrl: string): DataProvider {
        return this.cached[apiUrl] || (this.cached[apiUrl] = this.build(apiUrl));
    }
}
